import { Organization } from "./companyTypes";
import { PaginatedResponse } from "./globalTypes";

export enum UserRole {
  ADMIN = "ADMIN",
  USER = "USER",
}

export enum UserStatus {
  PENDING = "PENDING",
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
  SUSPENDED = "SUSPENDED",
}

export interface UserProfile {
  id: number;
  fullname: string;
  email: string;
  mobile: string;
  role: UserRole;
  status: UserStatus;
  avatar?: string | null;
  companyCount?: number;
  organization?: Organization | null;
}

export interface User {
  id: number;
  fullName: string;
  fullname?: string;
  email: string;
  mobile: string;
  role: UserRole;
  status: UserStatus;
  createdAt: string;
  deletedAt: string | null;
  updatedAt: string;
  password: string;
  avatar?: string | null;
  organization?: Organization | null;
  companyCount?: number;
}

export type UsersResponse = PaginatedResponse<User>;

// requests
export enum RequestStatusType {
  PENDING = "PENDING",
  IN_PROGRESS = "IN_PROGRESS",
  RESOLVED = "RESOLVED",
}

export interface RequestType {
  id: number;
  status: RequestStatusType;
  fullname: string;
  email: string;
  mobile: string;
  description: string;
  companyname: string;
  organizationstring: string | null;
  descriptionAdmin: string | null;
  createdAt: string;
  deletedAt: string | null;
  updatedAt: string | null;
}

export type RequestsResponse = PaginatedResponse<RequestType>;
